import React, { FC } from 'react';
import { Button, Card, Popover } from 'antd';
import { PURCHASE_REQUEST_STATUSES } from '../../constants/PurchaseRequestStatuses';
import UpdateSerialAndAssetNumbersModal from '../purchase_orders_detail_details_page/UpdateSerialAndAssetNumbersModal';
import usePurchaseRequestFulfill from './usePurchaseRequestFulfill';

interface PurchaseRequestOrderedOrFulfilledSectionProps {
	purchaseRequest: any;
	onSuccess: () => void;
}

const PurchaseRequestOrderedOrFulfilledSection: FC<
	PurchaseRequestOrderedOrFulfilledSectionProps
> = ({ purchaseRequest, onSuccess }) => {
	const {
		currentAction,
		PR_ACTIONS,
		equipmentLineItems,
		markFulfilledDisabledWithAssetTypeId,
		equipmentSerialNumberVisible,
		createdEntities,
		receivingEntityType,
		onOrdered,
		onFulfilled,
		hideSerialNumberUpdate,
		onUpdateSerialNumberSuccess,
		onReceiptValuesSuccessForPR,
	} = usePurchaseRequestFulfill(purchaseRequest, onSuccess);

	const isApproved = purchaseRequest.status === PURCHASE_REQUEST_STATUSES.approved;
	const isOrdered = purchaseRequest.status === PURCHASE_REQUEST_STATUSES.ordered;

	if (!isApproved && !isOrdered) return null;

	return (
		<div>
			<h5>
				{isApproved
					? 'Has this Purchase Request been ordered?'
					: 'Has the Purchase Request items been received? '}
			</h5>
			<div style={{ marginTop: 16, marginBottom: 40 }}>
				{isApproved ? (
					<Button type="primary" onClick={onOrdered} loading={currentAction === PR_ACTIONS.ORDER}>
						Yes, it was ordered
					</Button>
				) : (
					<Popover
						content={
							markFulfilledDisabledWithAssetTypeId
								? 'Please associate asset type with every equipment type in this purchase request!'
								: null
						}
						trigger="hover"
					>
						<Button
							type="primary"
							onClick={onFulfilled}
							disabled={markFulfilledDisabledWithAssetTypeId}
							loading={currentAction === PR_ACTIONS.FULFILL}
						>
							Yes, it was received
						</Button>
					</Popover>
				)}
			</div>
			{equipmentSerialNumberVisible && (
				<UpdateSerialAndAssetNumbersModal
					createdEntities={createdEntities}
					entityType={receivingEntityType}
					onSuccess={onUpdateSerialNumberSuccess}
					onCancel={hideSerialNumberUpdate}
					prLineItems={equipmentLineItems}
					onReceiptValuesSuccessForPR={onReceiptValuesSuccessForPR}
				/>
			)}
		</div>
	);
};

export default PurchaseRequestOrderedOrFulfilledSection;
